// extracted by mini-css-extract-plugin
export default {"CellContainer":"_CellContainer--xx75z","Center":"_Center--i1nc7","IconWrapper":"_IconWrapper--P3S1w","Icon":"_Icon--aKfhH"};